import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FiExternalLink, FiX } from 'react-icons/fi';
import { useAttachments } from "./AttachmentContext";

export default function ImageLightbox() {
    const { lightboxImage, lightboxOpen, setLightboxOpen } = useAttachments();

    return (
        <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen} modal={true}>
            <DialogContent className="max-w-[90vw] sm:max-w-[80vw] md:max-w-[70vw] lg:max-w-4xl p-0 bg-background border shadow-xl overflow-hidden">
                <div className="relative bg-black">
                    {/* Close button */}
                    <Button 
                        variant="ghost" 
                        size="icon" 
                        className="absolute top-2 right-2 z-20 h-8 w-8 bg-black/40 hover:bg-black/60 text-white"
                        onClick={() => setLightboxOpen(false)}
                    >
                        <FiX className="h-4 w-4" />
                    </Button>
                    
                    {/* Image */}
                    <div className="flex items-center justify-center max-h-[80vh] p-4">
                        {lightboxImage && (
                            <img 
                                src={lightboxImage.url} 
                                alt={lightboxImage.alt} 
                                className="max-w-full max-h-full object-contain" 
                            />
                        )}
                    </div>
                    
                    {/* Open button */}
                    {lightboxImage && (
                        <Button 
                            variant="ghost" 
                            size="icon" 
                            className="absolute top-2 right-12 z-20 h-8 w-8 bg-black/40 hover:bg-black/60 text-white"
                            onClick={() => window.open(lightboxImage.url, '_blank')}
                        >
                            <FiExternalLink className="h-4 w-4" />
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}